export enum EStatusBookingType {
  ExamStatus = 'exam-status',
  BookingStatus = 'booking-status'
}
